import BigScreenWebPage from "../../../unreal/BigScreenWebPage";
import {ISlsOrd} from "../../../kova/slsordClient";
import {useVscContext} from "../../content/VscReactContext";


export interface ICommunityMapProps {
    slsOrd?: ISlsOrd;
    viewBox?: [number, number, number, number]
}

export function BigScreenCommunityMap(props: ICommunityMapProps) {
    const vscContext = useVscContext();

    const { slsOrd } = props;
    let url = "/vsc/?root=" + encodeURIComponent(vscContext.getVisualizerControllerUri(''))
    if (props.viewBox) {
        url += `&viewBox=${props.viewBox.join("%20")}`;
    }

    if (slsOrd) {
        url += "#" + slsOrd.lotId;
    }

    return <BigScreenWebPage uri={vscContext.getVisualizerControllerUri(url)} />

}